import { keyframes, css } from 'styled-components/macro';
import { rgba } from 'polished';

export const COLORS = {
  error: '#fd286f',
  success: '#5df9a5',
  primary: '#552cba',
  line: '#3d3234',
  black: '#1a1616',
  background: '#282324',
  gray60: `${rgba('#fff', 0.6)}`,
  gray40: `${rgba('#fff', 0.4)}`,
  gray20: `${rgba('#fff', 0.2)}`,
  gray04: `${rgba('#fff', 0.04)}`,

  stub: '#33292b',
};

export const FULL_WIDTH = '1680px';
export const LEFT_COLUMN_WIDTH = '490px';
export const MAIN_COLUMN_WIDTH = '690px';
export const RIGHT_COLUMN_WIDTH = '408px';
export const DROPDOWN_WIDTH = '205px';
export const SMALL_HEADER_HEIGHT = '50px';

export const CHAT_ROOM_TABS_HEIGHT = '42px';

export const TYPOGRAPHY = {
  caption: css`
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-weight: normal;
  `,
  button: css`
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-weight: normal;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  `,
  body: css`
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: normal;
  `,
  bodySemibold: css`
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 600;
  `,
  name: css`
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: normal;
  `,
  title: css`
    font-family: 'Montserrat', sans-serif;
    font-size: 18px;
    font-weight: normal;
  `,
};

export const Z_INDEX = {
  unblock: 980,
  bubble: 970,
  logout: 1020,
  tooltip_select: 1030,
  pop_up_backdrop: 1990,
  pop_up: 2000,
  modal: 2020,
  modal_full_photo: 2030,
  confirm_modal: 2040,
  alert: 3000,
};

export const BOX_SHADOW = {
  dropdown: `0 4px 16px 0 ${rgba(COLORS.black, 0.6)}`,
};

export const MODAL_STYLES = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: Z_INDEX.modal,
  },
  content: {
    left: '50%',
    top: '50%',
    bottom: 'auto',
    right: 'auto',
    width: '420px',
    padding: '0',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    backgroundColor: 'transparent',
    boxShadow: BOX_SHADOW.dropdown,
    overflow: 'visible',
  },
};


export const easyMove = keyframes`
  from {
    transform: translateY(-20%);
    opacity: 0;
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const easyMoveX = keyframes`
  from {
    transform: translateX(20%);
    opacity: 0;
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
